import { useDocumentData } from 'react-firebase-hooks/firestore';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

export default function useShopDraftOrderConfig(shopId) {

  const ref = shopId ? firebase.firestore().collection('shops').doc(shopId).collection('installData').doc('draftOrders') : null;
  const [draftOrderConfig, draftOrderConfigLoading, draftOrderConfigError] = useDocumentData(ref);
  return { draftOrderConfig, draftOrderConfigLoading, draftOrderConfigError }
}